/** Daydream docClass keys — aligned with AECOClassifier DOC_CLASS_SIGNALS */
export const DOC_CLASS_OPTIONS = [
  'drawing',
  'spec',
  'report',
  'schedule',
  'manual',
  'cost',
  'contract',
  'closeout',
  'brief',
  'code',
  'permit',
  'form',
  'procurement',
  'heritage',
  'zoning',
  'environmental',
  'commissioning',
];

export const DOC_CLASS_LABELS = {
  drawing: 'Drawing',
  spec: 'Specification',
  code: 'Code',
  report: 'Report',
  brief: 'Brief',
  contract: 'Contract',
  schedule: 'Schedule',
  permit: 'Permit',
  manual: 'Manual',
  form: 'Form',
  cost: 'Cost / Estimate',
  procurement: 'Procurement',
  heritage: 'Heritage',
  zoning: 'Zoning',
  environmental: 'Environmental',
  commissioning: 'Commissioning',
  closeout: 'Closeout',
};

/** Default docClass options shown for Deliverable rows in ClassifierModal */
export const DELIVERABLE_DOC_CLASS_OPTIONS = [
  'drawing',
  'spec',
  'report',
  'schedule',
  'manual',
  'cost',
  'closeout',
];

const DRAWING_EXTENSIONS = new Set(['.pdf', '.dwg', '.dxf', '.svg']);

export function inferDocClassFromFileName(fileName = '') {
  const lower = String(fileName).toLowerCase();
  const ext = lower.includes('.') ? lower.slice(lower.lastIndexOf('.')) : '';
  const base = lower.replace(/\.[^.]+$/, '');

  if (['.dwg', '.dxf', '.svg'].includes(ext)) {
    return 'drawing';
  }

  if (/\b[acpfsm]-\d{2,4}\b/i.test(base) || /\b[acpfsm]\d{2,4}\b/i.test(base)) {
    return 'drawing';
  }

  if (/\b(floor plan|site plan|elevation|section|rcp|reflected ceiling|detail|drawing|as[- ]?built|coordination)\b/i.test(base)) {
    return 'drawing';
  }

  if (/\b(division[_\s-]?\d{1,2}|div[_\s-]?\d{1,2}|masterformat|spec(?:ification)?s?)\b/i.test(base)) {
    return 'spec';
  }

  if (/\b(residence|residential|project|plan set|architectural|working drawings|design drawings)\b/i.test(base)
    || /\d{4,}[_-].*(project|residence|arch|drawing)/i.test(base)) {
    return 'drawing';
  }

  if (/\b(rfi|submittal|transmittal|punch.?list|clarification)\b/i.test(base)) {
    return 'report';
  }

  if (/\b(requirements?|client brief|design brief)\b/i.test(base) || base.includes('requirement')) {
    return 'brief';
  }

  if (/\b(ccdc|contract|contracts|agreement|agreements|tender|general conditions|supplementary conditions|subcontract)\b/i.test(base)) {
    return 'contract';
  }

  return '';
}
